import { CUSTOM_ELEMENTS_SCHEMA, NgModule , NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ApiService } from './services/shared/api.service';
import { UserService } from './services/user/user.service';
import { ErrorMessageHandler } from './helpers/error-handler';
import { AuthService } from './services/shared/auth.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgWaTableModule } from 'ng-wa-table';
import { RouterModule } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SharedModule } from './layouts/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';


@NgModule({ declarations: [
    AppComponent,
],
bootstrap: [AppComponent],
schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
imports: [BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-clip-rotate' }),
    BrowserAnimationsModule,
    NgWaTableModule,
    RouterModule,
    NgxSkeletonLoaderModule,
    SharedModule,
   FormsModule,
    NgxDaterangepickerMd.forRoot()], providers: [ApiService, UserService, ErrorMessageHandler, AuthService, provideHttpClient(withInterceptorsFromDi()),] })
export class AppModule { }
